// extracted by css-extract-rspack-plugin
export default {"add":"add-LVG3B6","title":"title-wRN6b_","header":"header-Lmd08J","setting":"setting-Yd9ISJ","filter":"filter-HFGcCM","filters":"filters-ZvdYHb"};